import { Injectable } from "@angular/core";
import { catchError, Observable, of, ReplaySubject, tap } from "rxjs";
import { environment } from "@env/environment";
import { HttpClient } from "@angular/common/http";
import { Country, CountryRequest } from "./country.interface";

@Injectable()
export class CountryService {

    baseUrl = environment.administration_url + '/admin/countries';
    private _country: ReplaySubject<Country> = new ReplaySubject<Country>(1);
    private _countries: ReplaySubject<Country[]> = new ReplaySubject<Country[]>(1);

    set country(value: Country) {
        this._country.next(value);
    }

    get country$() {
        return this._country.asObservable();
    }

    set countries(value: Country[]) {
        this._countries.next(value);
    }

    get countries$() {
        return this._countries.asObservable();
    }

    constructor(
        private _httpClient: HttpClient
    ) { }

    getAll(): Observable<Country[]> {
        return this._httpClient.get<Country[]>(`${this.baseUrl}`)
        .pipe(
            tap((response: Country[]) => {
                this.countries = response || [];
                return response;
            }),
            catchError(() => of([]))
        );
    }

    getById(uuid: string): Observable<Country> {
        return this._httpClient.get<Country>(`${this.baseUrl}/${uuid}`)
        .pipe(
            tap((country) => {
                this.country = country;
                return country;
            }),
            catchError(() => of({} as Country))
        );
    }

    create(data: CountryRequest): Observable<Country> {
        return this._httpClient.post<Country>(`${this.baseUrl}`, data)
        .pipe(
            tap((country) => {
                this.country = country;
                return country;
            }),
            catchError(() => of({} as Country))
        );
    }

    update(uuid: string, data: CountryRequest): Observable<Country> {
        return this._httpClient.put<Country>(`${this.baseUrl}/${uuid}`, data)
        .pipe(
            tap((country) => {
                this.country = country;
                return country;
            }),
            catchError(() => of({} as Country))
        );
    }

    delete(uuid: string): Observable<void> {
        return this._httpClient.delete<void>(`${this.baseUrl}/${uuid}`)
        .pipe(
            catchError(() => of(undefined))
        );
    }
}
